import { useState, useCallback } from 'react';

interface UseAddCallLogDialogReturn {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
}

export const useAddCallLogDialog = (): UseAddCallLogDialogReturn => {
  const [open, setOpen] = useState(false);

  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);

  return {
    open,
    openDialog,
    closeDialog
  };
};
